import {identity} from 'shared/utils/identity';
import {BudgetUpdater, UpdatersRegistry} from '../types';

export function selectUpdaterFor(kind: RecordEntryKind, registry: UpdatersRegistry): BudgetUpdater {
  return registry[kind] || identity;
}
